import { PreviousNavigation } from 'common/helpers/previous-navigation';
import { PaginationMeta } from 'common/repositories/common.model';
import CreateSelectComponent from 'components/elements/create-select-component';
import LoaderSelectComponent from 'components/elements/loader-select-component';
import { useRouter } from 'next/router';
import React from 'react';

interface UseGetLabelSelectProps {
  setPage?: (value: React.SetStateAction<number>) => void;
  pagination?: PaginationMeta;
  loading?: boolean;
  onClickCreate?: () => void;
  setIsMenuOpen?: (value: React.SetStateAction<boolean>) => void;
}

export default function useGetLabelSelect(props: UseGetLabelSelectProps) {
  const { onClickCreate, setIsMenuOpen, loading, pagination, setPage } = props;
  const { asPath } = useRouter();
  const onNextPage = React.useCallback(() => {
    if (!pagination) return;
    if (loading) return;
    setPage?.(pagination.currentPage + 1);
  }, [loading, pagination, setPage]);

  const onCreate = React.useCallback(() => {
    PreviousNavigation.set(asPath);
    setIsMenuOpen?.(false);
    onClickCreate?.();
  }, [onClickCreate, asPath, setIsMenuOpen]);

  const getLabel = React.useCallback(
    ({ option }) => {
      if (option.id === 'actionLoad') {
        return (
          <div
            style={{
              padding: '8px 16px',
            }}
          >
            <LoaderSelectComponent onNextPage={onNextPage} />
          </div>
        );
      }

      if (option.id === 'actionCreate') {
        return (
          <div
            style={{
              padding: '8px 16px',
            }}
          >
            <CreateSelectComponent onCreate={onCreate} label={option.label} />
          </div>
        );
      }
      return <>{option.label}</>;
    },
    [onCreate, onNextPage],
  );

  return getLabel;
}
